module.exports = __webpack_public_path__ + "img/circle-4.2.70e1049d.svg";